/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

// Routes used in the sideb
import routes from "routes.js";

// inhouse icons
import { IoStarOutline, IoChevronDown } from "react-icons/io5";
import { FiChevronRight } from "react-icons/fi";

// Quick actions row (star + dropdown pill) sitting above the setup card
const QuickActions = () => (
  <div className="flex items-center gap-2 px-4 pt-3">
    <button
      aria-label="Favourites"
      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-[#3a4150] text-white hover:bg-[#232a36] transition-colors"
    >
      <IoStarOutline className="h-3.5 w-3.5" />
    </button>
    <button className="flex flex-1 items-center justify-center gap-2 rounded-full bg-white px-4 py-1 text-[13px] font-semibold text-[#111] hover:bg-[#eef0f4] transition-colors">
      Quick Actions
      <IoChevronDown className="h-3.5 w-3.5 text-[#111]" />
    </button>
  </div>
);

// Top-of-menu onboarding progress card (Wix-style)
const SetupCard = () => (
  <div className="px-5 pt-5 pb-4 border-b border-[#2a313d]">
    <button className="flex w-full items-center justify-between text-left">
      <span className="text-[13px] font-semibold text-white">
        Let's set up your business
      </span>
      <FiChevronRight className="h-3.5 w-3.5 shrink-0 text-white" />
    </button>
    <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-[#39414f]">
      <div className="h-full w-1/4 rounded-full bg-[#2b6ef2]" />
    </div>
    <p className="mt-1.5 text-[11px] text-[#aeb4c0]">2/8 completed</p>
  </div>
);

const Sidebar = ({ open, onClose }) => {
  return (
    <div className="flex min-h-full flex-col bg-[#141922] text-white">
      {/* The close button (X) */}
      <span className="absolute top-4 right-4 block cursor-pointer text-white xl:hidden" onClick={onClose}>
        <HiX />
      </span>

      {/* Quick actions + onboarding progress */}
      <QuickActions />
      <SetupCard />

      {/* Side navbar items */}
      <ul className="mb-auto py-[0.75em]">
        <Links routes={routes} />
      </ul>
    </div>
  );
};

export default Sidebar;
